import './index.scss';
import React, { useEffect, useMemo, useState } from 'react';
import { IPermissionContentProps } from '../../interface';
import { getPermissionList } from '@umu/umu-api';
import { PermissionType } from '../../../../interface';
import { shareOptionMap } from './../../../../dataFlow';
import { getProgramInfo } from '../../../../server';
import { If } from 'common/src/components';
import { lang } from '@umu/ukit-lang';
import { PermissionMemberList } from '../../../memberList';
import { Button } from '@umu/umu-design';

const ProgramPermissionInfo = (props: IPermissionContentProps) => {
    const {
        id,
        prefixCls = 'program-permission-info',
        showRefresh = false,
        normalizeAccountEPU,
        normalizeAccountName,
    } = props;
    const [dataInfo, setDataInfo] = useState<any>({
        permission: PermissionType.__INIT__,
        programInfo: null,
    });
    const [isReload, setIsReload] = useState(false);
    const onInit = (callBack?: () => void) => {
        Promise.all([
            getPermissionList({
                obj_id: id,
                obj_type: 'program',
            }),
            getProgramInfo({
                program_id: id,
            }),
        ]).then(([permissionInfo, programInfo]) => {
            setDataInfo({
                permission: permissionInfo.selected as PermissionType,
                programInfo,
            });
            callBack?.();
        });
    };
    useEffect(() => {
        onInit();
    }, [id]);
    const onRefresh = () => {
        setIsReload(false);
        onInit(() => {
            setIsReload(true);
        });
    };
    const { label, isShowCloseText, isShowAccount, labelSuffix } = useMemo(() => {
        const permission = String(dataInfo.permission) as PermissionType;
        return {
            label: shareOptionMap?.[permission]?.customLabel,
            labelSuffix: showRefresh ? (
                <Button type="text" className="btn-split" isOnlyChildren onClick={onRefresh}>
                    {lang('刷新')}
                </Button>
            ) : (
                ''
            ),
            isShowCloseText:
                permission === PermissionType.NONE_ALL && !!dataInfo?.programInfo?.setup?.accessPermissionTips,
            isShowAccount: permission === PermissionType.DESIGNATED_ACCOUNT,
        };
    }, [dataInfo.permission]);

    return (
        <div className={prefixCls}>
            <div className={`${prefixCls}-rows-split`}>
                {label}
                {labelSuffix}
            </div>
            <If condition={isShowCloseText && !!dataInfo.programInfo}>
                <div className={`${prefixCls}-rows-split`}>{`${lang('关闭提示语：')} ${
                    dataInfo.programInfo?.setup?.accessPermissionTips
                }`}</div>
            </If>
            <If condition={isShowAccount}>
                <PermissionMemberList
                    isModeView
                    id={id}
                    isReload={isReload}
                    sourceType={'program'}
                    normalizeAccountEPU={normalizeAccountEPU}
                    normalizeAccountName={normalizeAccountName}
                />
            </If>
        </div>
    );
};
export { ProgramPermissionInfo };
